import React, { useEffect, useState } from "react";
import CustomButton from "../CustomButton/CustomButton";
import Prices from "../Prices/Prices";
import { getRedirectUrlToDevicePage } from './ShopCard.utils'
import CompareBox from "../CompareBox/CompareBox";

const ShopCard = ({
  device,
  onLearnMore,
  tabText = "",
  labels,
  isFromListing ,
}) => {
  const { brand, characteristics } = device;
  const [selectedCharacteristic, setSelectedCharacteristic] = useState(null);
  const [deviceUrl, setDeviceUrl] = useState(device?.productUrl ?? '');

  const handleLearnMoreClick = (e) => {
    e.preventDefault();
    window.location.href = window.location.origin + deviceUrl;
  };

  const handleColorSelect = (selectedColor) => {
    setSelectedCharacteristic(
      characteristics.find((char) => char.color === selectedColor),
    );
  };

  useEffect(() => {
    if (characteristics) {
      setSelectedCharacteristic(characteristics[0]);
    }

  }, [characteristics]);

  useEffect(() => {
    const url = getRedirectUrlToDevicePage(device, selectedCharacteristic);
    if (typeof url == 'string') {
      setDeviceUrl(url);
    } else {
      setDeviceUrl(device?.productUrl ?? '');
    }
  }, [device, selectedCharacteristic])

  return (
    <div className="card border-0 shop-card">
      {/* Conditional Top Tag */}
      {tabText && (
        <div className="card-header">
          <span
            className="card-header-label"
            dangerouslySetInnerHTML={{ __html: tabText }}
          />
        </div>
      )}
      <div className="card-body text-center">
        <div className="device-top-section">
          <a href={`${window.location.origin}${deviceUrl}`} aria-label="Λεπτομέρειες προϊόντος">
            <div className="d-inline-flex align-items-center justify-content-center rounded-circle">
            {selectedCharacteristic?.imageUrl == null ||
            selectedCharacteristic?.imageUrl === "" ? (
              <img
                loading="lazy"
                src={window.location.origin + device?.imageUrl}
                className="first-shop-img"
                alt={selectedCharacteristic?.name}
              />
            ) : (
              <img
                loading="lazy"
                src={window.location.origin + selectedCharacteristic?.imageUrl}
                className="first-shop-img"
                alt={selectedCharacteristic?.name}
              />
            )}
          </div>
          </a>
          <div className={"bullet-icons"}>
            {characteristics
              ?.filter((char) => char?.color != null)
              ?.map((char, index) => (
                <span
                  key={index}
                  className={`g ${char?.color.toLowerCase()}`}
                  onClick={() => handleColorSelect(char?.color)}
                  style={{
                    border:
                      char?.productId !== device?.productId
                        ? "1px solid #dcdcdc"
                        : "none",
                    cursor: "pointer",
                    backgroundColor: char.color.toLowerCase(),
                  }}
                ></span>
              ))}
          </div>
          <div className="device-brand-text">{brand}</div>
          <div className="device-name-text">
            <a  href={`${window.location.origin}${deviceUrl}`}  aria-label={"Λεπτομέρειες προϊόντος"}>
              {selectedCharacteristic?.name
                ? selectedCharacteristic?.name
                : device.displayName}
            </a>
          </div>
        </div>
        {selectedCharacteristic?.stockNum <= 0 && selectedCharacteristic?.preOrder !== true && (
          <div className="availability-error-msg">Προσωρινά μη διαθέσιμο</div>
        )}
        <div className="device-bottom-section">
          <div className="shop-card-price-div">
            {selectedCharacteristic?.bundlePrice === undefined &&
            selectedCharacteristic?.initialPrice === undefined &&
            selectedCharacteristic?.finalPrice === undefined ? (
              <Prices item={device} labels={labels} isFromListing={isFromListing} />
            ) : (
              <Prices item={selectedCharacteristic} labels={labels} isFromListing={isFromListing}/>
            )}
          </div>
          <CustomButton className="device-btn" role={"button"}  onClick={handleLearnMoreClick}>
            {isFromListing === true
              ? labels[
                  selectedCharacteristic?.preOrder ? "comingSoon" : "learnMore"
                ]
              : labels["learnMore"]}
          </CustomButton>
          {isFromListing === true && (
              <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: '13px' }}>
                <CompareBox
                    product={device}
                    labels={labels}
                />
              </div>
          )}

        </div>
      </div>
    </div>
  );
};

export default ShopCard;
